import { useMemo } from 'react';
import { useUser } from '@/contexts/UserContext';
import { resolveExperience, type Experience } from '@/lib/experience';

/** The experience of the signed-in person (lib/experience.ts): derived from the account type, not from the company role. */
export function useExperience(): Experience {
  const { accountType, accountTypeResolved, userRole } = useUser();
  return useMemo(() => resolveExperience({ accountType: accountType ?? null, accountTypeResolved: !!accountTypeResolved, userRole: userRole ?? null }), [accountType, accountTypeResolved, userRole]);
}
